/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceLocationPermission } from './DeviceLocationPermission';
import {
    DeviceLocationPermissionFromJSON,
    DeviceLocationPermissionFromJSONTyped,
    DeviceLocationPermissionToJSON,
    DeviceLocationPermissionToJSONTyped,
} from './DeviceLocationPermission';
import type { LocationPreference } from './LocationPreference';
import {
    LocationPreferenceFromJSON,
    LocationPreferenceFromJSONTyped,
    LocationPreferenceToJSON,
    LocationPreferenceToJSONTyped,
} from './LocationPreference';
import type { SubscriptionTier } from './SubscriptionTier';
import {
    SubscriptionTierFromJSON,
    SubscriptionTierFromJSONTyped,
    SubscriptionTierToJSON,
    SubscriptionTierToJSONTyped,
} from './SubscriptionTier';

/**
 * 
 * @export
 * @interface OrgUserForClient
 */
export interface OrgUserForClient {
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    phone_number: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     */
    allow_location_tracking_while_compass_connected: boolean;
    /**
     * 
     * @type {LocationPreference}
     * @memberof OrgUserForClient
     */
    location_preference: LocationPreference;
    /**
     * 
     * @type {DeviceLocationPermission}
     * @memberof OrgUserForClient
     */
    device_location_permission?: DeviceLocationPermission;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    role: string;
    /**
     * 
     * @type {SubscriptionTier}
     * @memberof OrgUserForClient
     */
    effective_tier: SubscriptionTier;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    pvd_config_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    emergency_config_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     */
    should_force_apply_pvd_config: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     */
    should_force_apply_emergency_config: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    already_accepted_pvd_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    already_accepted_emergency_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    pending_org_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    unified_config_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    already_accepted_spec_etag?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     */
    should_force_apply_config: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    language_code: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     */
    is_prototyper: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrgUserForClient
     */
    last_interaction_timestamp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof OrgUserForClient
     */
    _ts: number;
    /**
     * 
     * @type {string}
     * @memberof OrgUserForClient
     * @deprecated
     */
    org_spec_azure_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgUserForClient
     * @deprecated
     */
    emergency_contact_auth_ids?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     * @deprecated
     */
    always_include_in_emergencies: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserForClient
     * @deprecated
     */
    auto_add_contacts: boolean;
}



/**
 * Check if a given object implements the OrgUserForClient interface.
 */
export function instanceOfOrgUserForClient(value: object): value is OrgUserForClient {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('allow_location_tracking_while_compass_connected' in value) || value['allow_location_tracking_while_compass_connected'] === undefined) return false;
    if (!('location_preference' in value) || value['location_preference'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('effective_tier' in value) || value['effective_tier'] === undefined) return false;
    if (!('pvd_config_id' in value) || value['pvd_config_id'] === undefined) return false;
    if (!('emergency_config_id' in value) || value['emergency_config_id'] === undefined) return false;
    if (!('should_force_apply_pvd_config' in value) || value['should_force_apply_pvd_config'] === undefined) return false;
    if (!('should_force_apply_emergency_config' in value) || value['should_force_apply_emergency_config'] === undefined) return false;
    if (!('unified_config_id' in value) || value['unified_config_id'] === undefined) return false;
    if (!('should_force_apply_config' in value) || value['should_force_apply_config'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('is_prototyper' in value) || value['is_prototyper'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    if (!('org_spec_azure_id' in value) || value['org_spec_azure_id'] === undefined) return false;
    if (!('always_include_in_emergencies' in value) || value['always_include_in_emergencies'] === undefined) return false;
    if (!('auto_add_contacts' in value) || value['auto_add_contacts'] === undefined) return false;
    return true;
}

export function OrgUserForClientFromJSON(json: any): OrgUserForClient {
    return OrgUserForClientFromJSONTyped(json, false);
}

export function OrgUserForClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserForClient {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'],
        'allow_location_tracking_while_compass_connected': json['allow_location_tracking_while_compass_connected'],
        'location_preference': LocationPreferenceFromJSON(json['location_preference']),
        'device_location_permission': json['device_location_permission'] == null ? undefined : DeviceLocationPermissionFromJSON(json['device_location_permission']),
        'role': json['role'],
        'effective_tier': SubscriptionTierFromJSON(json['effective_tier']),
        'pvd_config_id': json['pvd_config_id'],
        'emergency_config_id': json['emergency_config_id'],
        'should_force_apply_pvd_config': json['should_force_apply_pvd_config'],
        'should_force_apply_emergency_config': json['should_force_apply_emergency_config'],
        'already_accepted_pvd_etag': json['already_accepted_pvd_etag'] == null ? undefined : json['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': json['already_accepted_emergency_etag'] == null ? undefined : json['already_accepted_emergency_etag'],
        'pending_org_code': json['pending_org_code'] == null ? undefined : json['pending_org_code'],
        'unified_config_id': json['unified_config_id'],
        'already_accepted_spec_etag': json['already_accepted_spec_etag'] == null ? undefined : json['already_accepted_spec_etag'],
        'should_force_apply_config': json['should_force_apply_config'],
        'language_code': json['language_code'],
        'is_prototyper': json['is_prototyper'],
        'last_interaction_timestamp': json['last_interaction_timestamp'] == null ? undefined : json['last_interaction_timestamp'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'org_spec_azure_id': json['org_spec_azure_id'],
        'emergency_contact_auth_ids': json['emergency_contact_auth_ids'] == null ? undefined : json['emergency_contact_auth_ids'],
        'always_include_in_emergencies': json['always_include_in_emergencies'],
        'auto_add_contacts': json['auto_add_contacts'],
    };
}

export function OrgUserForClientToJSON(json: any): OrgUserForClient {
    return OrgUserForClientToJSONTyped(json, false);
}

export function OrgUserForClientToJSONTyped(value?: OrgUserForClient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'allow_location_tracking_while_compass_connected': value['allow_location_tracking_while_compass_connected'],
        'location_preference': LocationPreferenceToJSON(value['location_preference']),
        'device_location_permission': DeviceLocationPermissionToJSON(value['device_location_permission']),
        'role': value['role'],
        'effective_tier': SubscriptionTierToJSON(value['effective_tier']),
        'pvd_config_id': value['pvd_config_id'],
        'emergency_config_id': value['emergency_config_id'],
        'should_force_apply_pvd_config': value['should_force_apply_pvd_config'],
        'should_force_apply_emergency_config': value['should_force_apply_emergency_config'],
        'already_accepted_pvd_etag': value['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': value['already_accepted_emergency_etag'],
        'pending_org_code': value['pending_org_code'],
        'unified_config_id': value['unified_config_id'],
        'already_accepted_spec_etag': value['already_accepted_spec_etag'],
        'should_force_apply_config': value['should_force_apply_config'],
        'language_code': value['language_code'],
        'is_prototyper': value['is_prototyper'],
        'last_interaction_timestamp': value['last_interaction_timestamp'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
        'org_spec_azure_id': value['org_spec_azure_id'],
        'emergency_contact_auth_ids': value['emergency_contact_auth_ids'],
        'always_include_in_emergencies': value['always_include_in_emergencies'],
        'auto_add_contacts': value['auto_add_contacts'],
    };
}

